import { gql } from "@apollo/client"

export const GET_MY_USER_QUERY = gql`
    query MyUser {
        myUser {
            name
            email
            picture
            locale
            _id
            driver {
                contactNumber
                driversLicence {
                    licenceExpiry
                }
            }
            sites {
                site {
                    _id
                    name
                }
                siteDriverDetails {
                    allowedVehicles {
                        _id
                        licencePlate
                        identifier
                        odometer
                        engineNumber
                        capacity
                        gpsFrequency
                        shifts {
                            _id
                        }
                    }
                }
            }
            shifts {
                vehicle {
                    _id
                    identifier
                }
                jobs {
                    jobId
                    grouping {
                        type
                        groupId
                    }
                }
                _id
                shiftTemplateId
                shiftTemplateName
                shiftStart
                shiftEnd
                siteId
                siteName
                shiftHistory {
                    status
                    timestamp
                }
            }
        }
    }
`
